export default {
	VALIDATE_FORM: 'VALIDATE_FORM',
	SET_MAIL_INFO: 'SET_MAIL_INFO',
	SEND_MAIL: 'SEND_MAIL',
	CONTACT_FOR_PRODUCT: 'CONTACT_FOR_PRODUCT',
	SENDING_FAILED: 'SENDING_FAILED',
	SENDING_SUCCEEDED: 'SENDING_SUCCEEDED',
	SENDING_IN_PROGRESS: 'SENDING_IN_PROGRESS',
	INIT_MAIL: 'INIT_MAIL',
};



// WEBPACK FOOTER //
// ./src/redux/contact/actionTypes.js